import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { Role } from "src/services/user/role.enum";
import { AuthService } from "src/services/auth/auth.service";
import { adminPages, customerPages } from "src/services/navigation/paths.const";
import { User } from "src/services/user/user.interface";
import { promiseWithTimeout } from "src/services/utils/promise.utils";
import { isInKioskMode } from "src/services/utils/kiosk-mode.utils";
import { edition } from "@environments/edition";

export const RedirectToBlockedBasedOnRoleAndModeGuard = async (): Promise<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (isInKioskMode()) {
    return true;
  }

  if (edition.mode === "customerAndStaff") {
    return true;
  }

  let currentUser: User | undefined;
  try {
    currentUser = await promiseWithTimeout(authService.getActiveUser(), 5000, "timeout fetching user");
  } catch {
    currentUser = await authService.getActiveUser();
  }

  if (!currentUser) {
    return true;
  }

  const isStaff = currentUser?.role === Role.admin || currentUser?.role === Role.driver;
  const isStaffInStaffMode = isStaff && edition.mode === "staff";
  const isCustomerInCustomerMode = !isStaff && edition.mode === "customer";

  const isAllowedForThisMode = isStaffInStaffMode || isCustomerInCustomerMode;
  if (isAllowedForThisMode) {
    return true;
  }

  if (edition.mode === "staff") {
    return router.navigate([customerPages.adminOnly]);
  } else {
    return router.navigate([adminPages.customerOnly]);
  }
};
